<template>
  <div class="empty-container" :class="{ 'has-action': $slots.action }">
    <div class="empty-content">
      <!-- 图标区域 -->
      <div class="empty-icon">
        <slot name="icon">
          <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- 背景圆形 -->
            <circle
              cx="60"
              cy="60"
              r="50"
              stroke="#E5E5E5"
              stroke-width="2"
              fill="#F8F9FA"
            />
            <!-- 文档图标 -->
            <rect
              x="40"
              y="35"
              width="40"
              height="50"
              rx="2"
              stroke="#D0D0D0"
              stroke-width="2"
              fill="none"
            />
            <line
              x1="48"
              y1="48"
              x2="72"
              y2="48"
              stroke="#D0D0D0"
              stroke-width="2"
              stroke-linecap="round"
            />
            <line
              x1="48"
              y1="58"
              x2="72"
              y2="58"
              stroke="#D0D0D0"
              stroke-width="2"
              stroke-linecap="round"
            />
            <line
              x1="48"
              y1="68"
              x2="65"
              y2="68"
              stroke="#D0D0D0"
              stroke-width="2"
              stroke-linecap="round"
            />
            <!-- 装饰点 -->
            <circle
              cx="60"
              cy="90"
              r="4"
              fill="var(--primary-color)"
              opacity="0.3"
            />
            <circle
              cx="50"
              cy="95"
              r="3"
              fill="var(--primary-color)"
              opacity="0.2"
            />
            <circle
              cx="70"
              cy="95"
              r="3"
              fill="var(--primary-color)"
              opacity="0.2"
            />
          </svg>
        </slot>
      </div>

      <!-- 文字内容 -->
      <div class="empty-text">
        <h3 class="empty-title">{{ title || '暂无数据' }}</h3>
        <p v-if="description" class="empty-description">{{ description }}</p>
      </div>

      <!-- 操作按钮区域 -->
      <div v-if="$slots.action" class="empty-action">
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    // 主标题
    title: {
      type: String,
      default: '暂无数据'
    },
    // 描述文字
    description: {
      type: String,
      default: ''
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.empty-container {
  --primary-color: #{$primary-color};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 300px;
  padding: 40px 20px;
  background-color: transparent;
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 400px;
}

.empty-icon {
  margin-bottom: 24px;
  opacity: 0.8;
  animation: fadeInUp 0.6s ease-out;

  svg {
    width: 120px;
    height: 120px;
    transition: all 0.3s ease;
    filter: drop-shadow(0 2px 8px rgba($primary-color, 0.1));

    circle[fill="var(--primary-color)"] {
      animation: pulse 2s ease-in-out infinite;
    }
  }

  &:hover {
    opacity: 1;
    transform: translateY(-2px);

    svg {
      filter: drop-shadow(0 4px 12px rgba($primary-color, 0.15));
    }
  }
}

.empty-text {
  margin-bottom: 24px;
}

.empty-title {
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 12px 0;
  line-height: 1.5;
  animation: fadeInUp 0.6s ease-out 0.1s both;
}

.empty-description {
  font-size: 14px;
  color: #999999;
  margin: 0;
  line-height: 1.6;
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.empty-action {
  margin-top: 8px;
  animation: fadeInUp 0.6s ease-out 0.3s both;
}

// 动画效果
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.2);
  }
}

// 响应式设计
@media screen and (max-width: 768px) {
  .empty-container {
    min-height: 200px;
    padding: 30px 16px;
  }

  .empty-icon {
    margin-bottom: 20px;

    svg {
      width: 80px;
      height: 80px;
    }
  }

  .empty-title {
    font-size: 16px;
    margin-bottom: 8px;
  }

  .empty-description {
    font-size: 13px;
  }
}

// 当有操作按钮时的样式调整
.empty-container.has-action {
  .empty-text {
    margin-bottom: 32px;
  }
}
</style>

